import { render } from "./previewDetail.vue?vue&type=template&id=2e12529f&scoped=true"
import script from "./previewDetail.vue?vue&type=script&lang=ts"
export * from "./previewDetail.vue?vue&type=script&lang=ts"

import "./previewDetail.vue?vue&type=style&index=0&id=2e12529f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e12529f"

export default script